import { render, staticRenderFns } from "./NoPerm.vue?vue&type=template&id=ec85195a&scoped=true"
var script = {}
import style0 from "./NoPerm.vue?vue&type=style&index=0&id=ec85195a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec85195a",
  null
  
)

export default component.exports